import axios from "axios";

import { API_ENDPOINTS } from "../../../util/constants";

export const LOGIN_URL = API_ENDPOINTS.login;
export const REGISTER_URL = API_ENDPOINTS.register;
export const REQUEST_PASSWORD_URL = API_ENDPOINTS.forgotPassword;
export const RESET_PASSWORD_URL = API_ENDPOINTS.resetPassword;

export const ME_URL = API_ENDPOINTS.me;

export function login(email, password) {
  return axios.post(LOGIN_URL, { email, password });
}

export function register(email, fullname, username, password) {
  return axios.post(REGISTER_URL, { email, fullname, username, password });
}

export function requestPassword(email) {
  return axios.post(REQUEST_PASSWORD_URL, { email });
}

export function getUserByToken() {
  return axios.get(ME_URL);
}
